module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp3_3009.9c23419a.png";